var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.zoombarClass,attrs:{"id":"prj-zoom-bar-area"}})
}
var staticRenderFns = []

export { render, staticRenderFns }